import { Component, Input, OnInit } from '@angular/core';
import { getMprdProductType, Product } from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-usage-header',
  templateUrl: './usage-header.component.html',
})
export class UsageHeaderComponent implements OnInit {
  remainingDays: string;
  productTypeUsageHeaderKey: string;
  isExceedingAmountShown: boolean;

  @Input() product: Product;
  @Input() remainingDaysLabel: string;
  constructor(private readonly translationService: TranslationService) {}

  ngOnInit() {
    this.isExceedingAmountShown =
      (
        this.translationService.getTranslatedValueFor(
          'products.overview.Ebu.exceedingBillNotShown.productIds',
        ) ?? 'false'
      )
        .split(',')
        .indexOf(this.product.productId) === -1;
    this.productTypeUsageHeaderKey =
      'px-' + getMprdProductType(this.product) + '-usage-header';
    if (this.product.brand !== 'prepaid') {
      this.remainingDays = this.remainingDaysLabel;
    }
  }
}
